import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Constants } from "../../Common/Constants";
// import { fetchWorkoutAnalytics } from "../../../Redux/Actions";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useSelector } from "react-redux";
import * as XLSX from "xlsx";
import ExcelIcon from "../../../assets/images/excel.png";
import Spinner from "../../../assets/images/Spinner.gif";
import { getExerciseWiseStrengthAssessmentReportAction, getStrengthAssessmentReportAction, getTotalWeightsLiftedReportAction, getTotalWorkoutReportAction, getTotalWorkoutsCompletedHourlyAction, getUserGoalCountReportAction, getWorkoutCompletedReportAction } from "../../../Redux/Actions/WorkoutAnalyticsActions";
import ReactSelect from "../../Common/Fields/ReactSelect";
import usePermissions from "../../Common/Functions/usePermissions";
import TabsBootstrap from "../../Common/UiModel/TabsBootstrap";
import Monthly from "./Monthly";
import Quarterly from "./Quarterly";
import Weekly from "./Weekly";
import Yearly from "./Yearly";


dayjs.extend(utc);
dayjs.extend(timezone);

const WorkoutAnalytics = () => {
  const totalWorkouts = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.workouts);
  const totalReps = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.reps);
  const totalWeightsLifted = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.totalWeightLifted);
  const totalWorkoutSession = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.duration);
  const caloriesBurnt = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.caloriesBurnt);
  const totalTimeUnderTension = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.timeUnderTension);
  const userStrengthAssessment = useSelector((store) => store.WorkOutAnalyticsReportReducer.strengthAssessmentReport);
  const userGoalGetLeaner = useSelector((store) => store.WorkOutAnalyticsReportReducer.userGoalCountReport.getLeaner);
  const userGoalGetStronger = useSelector((store) => store.WorkOutAnalyticsReportReducer.userGoalCountReport.getStronger);
  const totalWorkoutsCompletedHourly = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutsCompletedHourly.workouts);
  const avgSessionDuration = useSelector((store) => store.WorkOutAnalyticsReportReducer.totalWorkoutReport.avgSessionDuration);


  const tabsList = [
    {
      eventKey: Constants.analyticsWeek,
      title: Constants.analyticsSevenDays,
      component: <Weekly />,
    },
    {
      eventKey: Constants.analyticsMonth,
      title: Constants.analyticsThirtyDays,
      component: <Monthly />,
    },
    {
      eventKey: Constants.analyticsThreeMonths,
      title: Constants.analyticsNinetyDays,
      component: <Quarterly />,
    },
    {
      eventKey: Constants.analyticsYear,
      title: Constants.analyticsOneYear,
      component: <Yearly />,
    },
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activetab, setActiveTab] = useState(tabsList?.[0]?.eventKey);
  const [selectedGender, setSelectedGender] = useState(
    Constants.genderOptions?.[0]
  );
  const [loader, setLoader] = useState(false);
  // Permissions
  const viewPermission = usePermissions(
    Constants.permission.DOWNLOAD_REPORT_VIEW
  );

  useEffect(() => {
    // const data = { days: activetab, gender: selectedGender.value };
    const today = new Date();
    //  const formattedDate = today.toISOString().split("T")[0];

    // e.g. "Asia/Kolkata"
    const tz = dayjs.tz.guess();

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const formattedDate = tomorrow.toISOString().split("T")[0];
    const data2 = { noofdays: activetab, gender: selectedGender.value, currentDate: formattedDate, tz };

    // dispatch(fetchWorkoutAnalytics(data));

    dispatch(getTotalWorkoutReportAction(data2));
    dispatch(getStrengthAssessmentReportAction(data2));
    dispatch(getUserGoalCountReportAction(data2));
    dispatch(getWorkoutCompletedReportAction(data2));
    dispatch(getExerciseWiseStrengthAssessmentReportAction(data2));
    dispatch(getTotalWeightsLiftedReportAction(data2));
    dispatch(getTotalWorkoutsCompletedHourlyAction(data2));
  }, [activetab, selectedGender]);

  useEffect(() => {
    // Set active tab as per URL
    const queryParams = new URLSearchParams(location.search);
    const tabParam = queryParams.get(Constants.activeTab);
    if (tabParam && tabsList.map((elt) => elt.eventKey).includes(tabParam)) {
      setActiveTab(tabParam);
    }
  }, [location]);

  const handleTabSelect = (key) => {
    // Set URL in correspondance with active tab
    setActiveTab(key);
    const queryParams = new URLSearchParams(location.search);
    queryParams.set(Constants.activeTab, key);
    navigate(`?${queryParams.toString()}`);
  };

  // const onExportExcel = async () => {
  //   setLoader(true);
  //   const data = { days: activetab, gender: selectedGender.value };
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL}${ApiUrl.WORKOUT_REPORT_EXCEL}?days=${data?.days
  //       }${data?.gender ? `&gender=${data?.gender}` : ""}`,
  //       {
  //         baseURL: `${process.env.REACT_APP_API_URL}`,
  //         responseType: "blob",
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem(
  //             Constants.accessToken
  //           )}`,
  //         },
  //       }
  //     );
  //     setLoader(false);
  //     // Create a Blob from the data and generate a download link
  //     const url = window.URL.createObjectURL(new Blob([response.data]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "Reports.xlsx");
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //   } catch (error) {
  //     setLoader(false);
  //     console.error("Error downloading the Excel file:", error);
  //   }
  // };


  const onExportExcel = () => {
    setLoader(true);
    const metrics = [
      { key: "totalWorkouts", value: totalWorkouts },
      { key: "totalReps", value: totalReps },
      { key: "totalWeightsLifted", value: totalWeightsLifted },
      { key: "totalWorkoutSession", value: totalWorkoutSession },
      { key: "caloriesBurnt", value: caloriesBurnt },
      { key: "totalTimeUnderTension", value: totalTimeUnderTension },
      { key: "userStrengthAssessment", value: userStrengthAssessment },
      { key: "userGoalGetLeaner", value: userGoalGetLeaner },
      { key: "userGoalGetStronger", value: userGoalGetStronger },
      { key: "totalWorkoutsCompletedHourly", value: totalWorkoutsCompletedHourly },
      { key: "avgSessionDuration", value: avgSessionDuration },
    ];
    // data to be written to the workbook.
    const dataForWorkBook = {};


    // convert the metrics array data to arrays of objects so that it can be written to the excel sheets.
    metrics.forEach(function (item, index) {
      const result = item.value.dates.map((day, i) => ({
        date: day,
        count: item.value.recordcounts[i],
        gender: selectedGender.label
      }));

      dataForWorkBook[item.key] = result;
    });

    const workbook = XLSX.utils.book_new();
    // loop through the workbook data, create a sheet and append the sheet to workbook
    Object.keys(dataForWorkBook).forEach(function (item, index) {
      const worksheet = XLSX.utils.json_to_sheet(dataForWorkBook[item]);
      XLSX.utils.book_append_sheet(workbook, worksheet, item);
    });


    XLSX.writeFile(workbook, "workout-analytics-report.xlsx");
    setLoader(false);
  };
  return (
    <div className="container-xxl">
      <div className="catalog_box al_catalog_box mt-4">
        <div className="row row_end order-list-view">
          <div className="col-md-2 filter-tabs">
            <ReactSelect
              label={Constants.gender}
              options={Constants.genderOptions}
              onChange={(e) => setSelectedGender(e)}
              value={selectedGender}
            />
          </div>
          {viewPermission && (
            <>
              {loader ? (
                <div className="col-md-1 filter-tabs">
                  <img src={Spinner} alt="spinner" width="40px" height="40px" />
                </div>
              ) : (
                <div className="col-md-1 filter-tabs">
                  <div className="btn-hover">
                    <button
                      onClick={() => {
                        onExportExcel();
                      }}
                      title=""
                      className="btn btn-primary text-uppercase"
                    >
                      <img
                        src={ExcelIcon}
                        alt="excel-icon"
                        className="img-excel"
                      />
                      {Constants.export}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <TabsBootstrap
          defaultActiveKey={activetab}
          onSelect={(index) => {
            setActiveTab(index);
          }}
          activeKey={activetab}
          handleTabSelect={handleTabSelect}
          options={tabsList}
        />
      </div>
    </div>
  );
};

export default WorkoutAnalytics;
